export const getFocusableChildren = (el: Element): NodeListOf<Element> =>
  el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
